import React, { useState, useEffect } from "react";
import configuration from "../configuration";
import Routers from "../Routes";
import { useAppSelector, useAppDispatch } from "../Store/Readux/Hooks";
import { setWindowsSize } from "../Store/Readux/Reducer/GlobalSlice";
import { ThemeProvider } from "styled-components";
import Loader from "../Components/base/Loader";

const App = () => {
  const dispatch = useAppDispatch();
  const [windowSize, setWindowSize] = useState({ width: 0, height: 0 });
  const loading = useAppSelector((state) => state.loader.globalLoading);

  const { light_theme } = configuration;
  var theme = light_theme;

  dispatch(setWindowsSize(windowSize));

  return (
    <>
      <ThemeProvider theme={theme}>
        {loading && (
          <div className="global-loader">
            <Loader />
          </div>
        )}
        <Routers />
      </ThemeProvider>
    </>
  );
};

export default App;
